import { Static, Type } from '@sinclair/typebox'

export const Usage = Type.Object({
    tasks: Type.Number(),
    activeFlows: Type.Number(),
    resetDate: Type.String(),
})
export type Usage = Static<typeof Usage>
